//base
import './build/setVers.js';
import './build/anchor.js';
import './build/HeaderNavigation.js';
import './build/pagetop.js';
import './build/changeRegisterTab.js';
import './build/addJobHistoryBlock.js';
import './build/formAgree.js';
import './build/selectFIle.js';
import './build/formAgree.js';
import './build/sidebarAccordion.js';
import './build/addHeaderAnchor.js';
import './build/inquiryValidateControl.js';
import './build/inquiryAcceptance.js';
import './build/articleSlider.js';
import observerShowObj from './build/observerShowObj';
import Cookies from 'js-cookie';

// [クラス作成] observerで表示するオブジェクト
// ターゲット：p-observer
// 過ぎたら表示：data-show-exclude属性
const observerElem = document.getElementsByClassName('p-observer');
const createObserveObj = () => {
  //通常の場合
  if (!observerElem.length) return;
  for (let i = 0; i < observerElem.length; i++) {
    new observerShowObj(observerElem[i],document.querySelector(observerElem[i].dataset.showExclude));
  }
}
document.addEventListener('DOMContentLoaded', createObserveObj, false);

const jobDetailBookMark = () => {
  let bookMarkButtons = document.querySelectorAll('.js-bookmark-button');
  let bookMarkId = document.querySelector('body').getAttribute('data-job-id');

  const clickBookMark = () => {
    let bookMarkIds = Cookies.get('bookmarks') ? JSON.parse( Cookies.get('bookmarks') ) : [];
    if (bookMarkIds.indexOf(bookMarkId) > -1) {
      bookMarkIds.splice(bookMarkId, 1);
    } else {
      bookMarkIds.push(bookMarkId);
    }
    const serializedArr = JSON.stringify( bookMarkIds );
    if(bookMarkIds.length >= 16) {
      return;
    } else {
      Cookies.set('bookmarks',serializedArr, { expires: 30, path: '/' });
      checkedInspect();
    }
  };
  const checkedInspect = () =>{
    let bookMarkIds = Cookies.get('bookmarks') ? JSON.parse( Cookies.get('bookmarks') ) : [];
    if (bookMarkIds.indexOf(bookMarkId) > -1) {
      for (let i = 0; i < bookMarkButtons.length; i++) {
        bookMarkButtons[i].classList.add('is-bookmark');
      }
    } else {
      for (let i = 0; i < bookMarkButtons.length; i++) {
        bookMarkButtons[i].classList.remove('is-bookmark');
      }
    }
  }
  checkedInspect();
  for(let i = 0; i < bookMarkButtons.length; i++){
    bookMarkButtons[i].addEventListener('click',() => {
      clickBookMark();
    }, false);
  }
};

window.addEventListener('load', jobDetailBookMark,false);

// 検索コンテンツ生成
import { createApp } from 'vue';
import FindNavi from './VueComponents/FindNavi.vue';
window.addEventListener('DOMContentLoaded', () => {
  createApp(FindNavi).mount('#find-navi-content');
})

/**============================================================
*   [共通] パネル型記事スライダー
*   target : .p-article-card-slider
============================================================*/
import ArticleSlider from './build/articleSlider.js';
const ArticleSliderElem = document.getElementsByClassName('p-article-card-swiper');
const createArticleSliderObj = () => {
  if (!ArticleSliderElem.length) return;
  for (let i = 0; i < ArticleSliderElem.length; i++) {
    new ArticleSlider(ArticleSliderElem[i], i);
  }
}
document.addEventListener('DOMContentLoaded', createArticleSliderObj, false);
